document.addEventListener('DOMContentLoaded', function () {
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  }

  function showErrorPopup() {
    const errorPopup = document.querySelector('.error-popup');
    if (!errorPopup) return;

    errorPopup.classList.add('active');
    setTimeout(function () {
      errorPopup.classList.remove('active');
    }, 4000);
  }

  function setErrorTexts(isEmpty, errorfieldsName) {
    const errorPopup = document.querySelector('.error-popup');
    if (!errorPopup) return;

    const emptyErrorText = errorPopup.querySelector('.error-popup-content-text.empty');
    const unvalidErrorText = errorPopup.querySelector('.error-popup-content-text.unvalid');

    if (!emptyErrorText || !unvalidErrorText) return;

    if (isEmpty) {
      emptyErrorText.style.display = 'block';
      unvalidErrorText.style.display = 'none';
      emptyErrorText.textContent = emptyErrorText.textContent.replace('""', '"' + errorfieldsName + '"');
    } else {
      emptyErrorText.style.display = 'none';
      unvalidErrorText.style.display = 'block';
      unvalidErrorText.textContent = unvalidErrorText.textContent.replace('""', '"' + errorfieldsName + '"');
    }

    showErrorPopup();
  }

  async function subscribeEmailToKlaviyo(email) {
    let language = 'EN';

    console.log(window.KL_LANGUAGE, window.userCountry);
    if (window.KL_LANGUAGE === 'fr') {
      language = 'FR';
    } else if (window.KL_LANGUAGE === 'en' && window.userCountry === 'us') {
      language = 'en-US';
    } else if (window.KL_LANGUAGE === 'de') {
      language = 'DE';
    } else if (window.KL_LANGUAGE === 'nl') {
      language = 'NL';
    } else if (window.KL_LANGUAGE === 'pl') {
      language = 'PL';
    }

    const payload = {
      $email: email,
      Language: language,
    };

    if (window.klaviyo) {
      try {
        await window.klaviyo.identify(payload);
        await window.klaviyo.track('Footer Subscription', payload);
      } catch (error) {
        console.warn('Klaviyo identify/track error:', error);
      }
    }

    const body = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                properties: { newKey: 'New Value' },
                subscriptions: {
                  email: { marketing: { consent: 'SUBSCRIBED' } },
                },
              },
            },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: 'RwNhZj' } },
        },
      },
    };

    const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=UQzMTp', {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2025-10-15',
        'content-type': 'application/vnd.api+json',
      },
      body: JSON.stringify(body),
    });

    return response.ok;
  }

  function initFooterSubscriptionForm() {
    const subscriptionForms = document.querySelectorAll('.dnc-footer-new-action-subscription-form');

    if (!subscriptionForms.length) return;

    subscriptionForms.forEach(function (subscriptionForm) {
      const emailInput = subscriptionForm.querySelector('.dnc-footer-new-action-subscription-input');
      const submitBtn = subscriptionForm.querySelector('.dnc-footer-new-action-subscription-btn');
      const successPopup = subscriptionForm.querySelector('.dnc-footer-new-action-subscription-success-popup');
      const successCloseBtn = subscriptionForm.querySelector('.dnc-footer-new-action-subscription-success-close-btn');

      if (!emailInput || !submitBtn || !successPopup || !successCloseBtn) return;

      function closeSuccessPopup() {
        successPopup.classList.remove('active');
      }

      successCloseBtn.addEventListener('click', closeSuccessPopup);

      emailInput.addEventListener('input', function () {
        emailInput.classList.remove('error');
      });

      emailInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          submitBtn.click();
        }
      });

      submitBtn.addEventListener('click', async function (event) {
        event.preventDefault();

        const email = emailInput.value.trim();

        if (email.length < 5) {
          emailInput.classList.add('error');
          setErrorTexts(true, 'Email');
          return;
        }

        if (!isValidEmail(email)) {
          emailInput.classList.add('error');
          setErrorTexts(false, 'Email');
          return;
        }

        emailInput.classList.remove('error');

        if (submitBtn.disabled) return;

        submitBtn.classList.add('loading');
        submitBtn.setAttribute('aria-busy', 'true');
        submitBtn.disabled = true;

        try {
          const isSuccess = await subscribeEmailToKlaviyo(email);

          if (isSuccess) {
            successPopup.classList.add('active');
            emailInput.value = '';
            return;
          }

          setErrorTexts(false, 'Email');
        } catch (error) {
          setErrorTexts(false, 'Email');
        } finally {
          submitBtn.classList.remove('loading');
          submitBtn.removeAttribute('aria-busy');
          submitBtn.disabled = false;
        }
      });
    });
  }

  function showCookieSettings() {
    if (window.CookieScript) {
      CookieScript.instance.show();
    } else {
      console.warn('CookieScript is not loaded yet.');
    }
  }

  function initCookieSettingsButton() {
    const cookieSettingsBtn = document.querySelectorAll('.cookies-popup-open-btn');
    if (cookieSettingsBtn) {
      cookieSettingsBtn.forEach((btn) => {
        btn.addEventListener('click', showCookieSettings);
      });
    } else {
      console.warn('Cookie settings button not found.');
    }
  }

  function showMorePaymentOptions() {
    const paymentSections = document.querySelectorAll('.dnc-footer-new-link-action-bottom-payment-icons');

    if (!paymentSections.length) {
      console.warn('More payment options button or popup not found.');
      return;
    }

    paymentSections.forEach(function (paymentSection) {
      const moreBtn = paymentSection.querySelector('.dnc-footer-new-link-action-bottom-payment-more-btn');
      const popup = paymentSection.querySelector('.dnc-footer-new-link-action-popup-more');

      if (!moreBtn || !popup) return;

      let popupTimeout;

      function closePopup() {
        popup.classList.remove('active');

        if (popupTimeout) {
          clearTimeout(popupTimeout);
          popupTimeout = null;
        }
      }

      function openPopup() {
        popup.classList.add('active');

        if (popupTimeout) {
          clearTimeout(popupTimeout);
        }

        popupTimeout = setTimeout(closePopup, 4000);
      }

      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        moreBtn.addEventListener('mouseenter', function () {
          popup.classList.add('active');
        });
        moreBtn.addEventListener('mouseleave', closePopup);
      }

      moreBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        openPopup();
      });

      document.addEventListener('click', function (event) {
        if (!paymentSection.contains(event.target)) {
          closePopup();
        }
      });
    });
  }

  function openDesktopAccessoriesMenu() {
    const accessoriesSubmenu = document.querySelector('.header-desktop-submenu-wrp.submenu-accessories');
    const headerDesktopMenuUl = document.querySelector('.header-desktop-menu');
    if (!accessoriesSubmenu || !headerDesktopMenuUl) return false;

    const accessoriesMenuItem = accessoriesSubmenu.closest('.desktop-menu-menu-item.has-children');

    if (!accessoriesMenuItem) return false;

    document.querySelectorAll('.desktop-menu-menu-item.has-children.open').forEach((item) => {
      item.classList.remove('open');
    });

    accessoriesMenuItem.classList.add('open');
    headerDesktopMenuUl.classList.add('submenu-open');

    const newProductsSubmenu = document.querySelector('.header-container-submenu.new-products');
    const refurbishedProductsSubmenu = document.querySelector('.header-container-submenu.refurbished-products');

    if (newProductsSubmenu) {
      newProductsSubmenu.classList.add('menu-visible');
    }
    if (refurbishedProductsSubmenu) {
      refurbishedProductsSubmenu.classList.remove('menu-visible');
    }
    return true;
  }

  function ensureDesktopHeaderVisible() {
    const header = document.getElementById('header-2');
    if (!header) return;

    header.classList.remove('down-scroll');
    header.classList.add('up-scroll');
  }

  function openMobileAccessoriesMenu() {
    const mobileMenuToggleButton = document.querySelector('.mobile-menu-toggle-button');
    const accessoriesToggleButton = document.getElementById('mobile-menu-accessories-toggle');
    const mobileMenuWrp = document.querySelector('.header-mobile-menu-wrp');
    if (!accessoriesToggleButton) return false;

    if (mobileMenuToggleButton && !document.body.classList.contains('mobile-menu-open')) {
      mobileMenuToggleButton.click();
    }

    if (mobileMenuWrp && !mobileMenuWrp.classList.contains('accessories-open')) {
      accessoriesToggleButton.click();
    }
    return true;
  }

  function initFooterAccessoriesLink() {
    document.addEventListener('click', function (event) {
      const link = event.target.closest('.dnc-footer-new-link-item-text.accesories');

      if (!link) return;

      event.preventDefault();
      const isMobileViewport = window.matchMedia('(max-width: 1024px)').matches;

      if (!isMobileViewport) {
        ensureDesktopHeaderVisible();
      }

      const opened = isMobileViewport ? openMobileAccessoriesMenu() : openDesktopAccessoriesMenu();
      if (!opened) {
        if (isMobileViewport) {
          openDesktopAccessoriesMenu();
        } else {
          openMobileAccessoriesMenu();
        }
      }
    });
  }

  showMorePaymentOptions();
  initCookieSettingsButton();
  initFooterSubscriptionForm();
  initFooterAccessoriesLink();
});
